import getUserProfileValidate from "./getUserProfileValidate"

export const INFO_MESSAGE_RESTRICTED = "_INFO_MESSAGE_RESTRICTED_INFO_"
export const INFO_MESSAGE_DELETED = "_INFO_MESSAGE_DELETED_INFO_"

export function mensagemPlaceholderVisibilidadeEh(cBody) {
  return cBody === INFO_MESSAGE_RESTRICTED || cBody === INFO_MESSAGE_DELETED
}

function mensagemConteudoMascarar(oAlvo, cPlaceholder) {
  return {
    ...oAlvo,
    body: cPlaceholder,
    mediaUrl: null,
    dataJson: null,
  }
}

function mensagemAlvoMascarar(oAlvo, oUsuario, { lCanalInterno, nTicketResponsavelId }) {
  if (!oAlvo) return oAlvo

  if (lCanalInterno) {
    if (oAlvo.isDeleted && oUsuario.profile !== "admin" && oUsuario.id !== oAlvo.usuarioId) {
      return mensagemConteudoMascarar(oAlvo, INFO_MESSAGE_DELETED)
    }
    return oAlvo
  }

  const oAutor = oAlvo.usuario ?? oAlvo.user
  const oDados = {
    message: {
      usuario: oAutor,
      user: oAutor,
      filaId: oAlvo.filaId,
    },
    ticket: { messages: [], responsavelId: nTicketResponsavelId ?? null },
  }

  if (!getUserProfileValidate(oUsuario, oDados)) {
    return mensagemConteudoMascarar(oAlvo, INFO_MESSAGE_RESTRICTED)
  }

  return oAlvo
}

/**
 * Aplica visibilidade ao pai e à citação (defesa em profundidade no cliente / socket).
 * @param {object} oMensagem
 * @param {object} oUsuario
 * @param {{ lCanalInterno?: boolean }} [oOpcoes]
 */
export default function mensagemVisibilidadeClienteAplicar(oMensagem, oUsuario, oOpcoes = {}) {
  if (!oMensagem || !oUsuario) return oMensagem

  const { lCanalInterno = false, nTicketResponsavelId = null } = oOpcoes
  const oContextoVisibilidade = { lCanalInterno, nTicketResponsavelId }
  let oResultado = mensagemAlvoMascarar(oMensagem, oUsuario, oContextoVisibilidade)

  if (oResultado.quotedMsg) {
    oResultado = {
      ...oResultado,
      quotedMsg: mensagemAlvoMascarar(oResultado.quotedMsg, oUsuario, oContextoVisibilidade),
    }
  }

  return oResultado
}
